var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#bfebff;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "provider_register",
    "data-name": "provider register"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 299.58,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323,272.52a94.7,94.7,0,0,1,48.36,13,96,96,0,0,1,35.36,35.36,94.7,94.7,0,0,1,13,48.36v30.31A34.48,34.48,0,0,1,385,434.18H131a34.48,34.48,0,0,1-34.64-34.64V369.23a94.7,94.7,0,0,1,13-48.36,96,96,0,0,1,35.36-35.36,94.7,94.7,0,0,1,48.36-13h12.27a125.91,125.91,0,0,0,105.36,0ZM258,249.43a91.58,91.58,0,0,1-46.55-12.27,89.93,89.93,0,0,1-33.56-33.56,94.44,94.44,0,0,1,0-93.1,89.86,89.86,0,0,1,33.56-33.56,94.44,94.44,0,0,1,93.1,0,89.86,89.86,0,0,1,33.56,33.56,94.44,94.44,0,0,1,0,93.1,89.93,89.93,0,0,1-33.56,33.56A91.58,91.58,0,0,1,258,249.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.39,515.3A51.33,51.33,0,0,1,353.13,464v-40.2h-36.9a51.27,51.27,0,1,1,0-102.53h36.9V281.16a51.27,51.27,0,1,1,102.53,0V321.3H499.1a51.27,51.27,0,1,1,0,102.53H455.66V464A51.33,51.33,0,0,1,404.39,515.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.39,244.89a36.37,36.37,0,0,1,36.27,36.27V336.3H499.1a36.27,36.27,0,1,1,0,72.53H440.66V464a36.37,36.37,0,0,1-36.27,36.27h0A36.37,36.37,0,0,1,368.13,464v-55.2h-51.9a36.27,36.27,0,1,1,0-72.53h51.9V281.16a36.37,36.37,0,0,1,36.26-36.27h0m0-30a66.34,66.34,0,0,0-66.26,66.27V306.3h-21.9a66.27,66.27,0,1,0,0,132.53h21.9V464a66.27,66.27,0,1,0,132.53,0v-25.2H499.1a66.27,66.27,0,1,0,0-132.53H470.66V281.16a66.34,66.34,0,0,0-66.27-66.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderRegister);
export default __webpack_public_path__ + "static/media/provider_register.60233b7d32606807b0900f49e651b757.svg";
export { ForwardRef as ReactComponent };